import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Request from '../../services/Request';
import { Box, Typography, Paper } from '@mui/material';

function getClientIdFromState(state: string | null): string {
  if (!state) return '';
  
  try {
    // Decode from base64 first
    const decodedState = atob(state);
    
    try {
      // Try JSON first
      const parsed = JSON.parse(decodedState);
      if (parsed.roClientId) return parsed.roClientId;
    } catch {
      // Fallback: try query string format
      const params = new URLSearchParams(decodedState);
      if (params.has('roClientId')) return params.get('roClientId') || '';
    }
  } catch (e) {
    // If base64 decoding fails, try the original approaches
    try {
      const parsed = JSON.parse(state);
      if (parsed.roClientId) return parsed.roClientId;
    } catch {
      const params = new URLSearchParams(state);
      if (params.has('roClientId')) return params.get('roClientId') || '';
    }
  }
  
  return '';
}

const ShopifyAuthLanding: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [message, setMessage] = useState('Connecting to Shopify...');

  useEffect(() => {
    const shop = searchParams.get('shop') || '';
    const code = searchParams.get('code') || '';
    const state = searchParams.get('state');
    const clientId = getClientIdFromState(state);

    const authorize = async () => {
      if (!clientId || !code || !shop) {
        setMessage('Missing required parameters for Shopify authentication. You may close this page.');
        setSearchParams({});
        return;
      }
      try {
        await Request.post(`/api/clients/${clientId}/shopify-auth`, {
          auth_code: code,
          client_url: shop
        });
        setMessage('Shopify connected successfully! You may now close this page.');
      } catch {
        setMessage('Failed to authenticate with Shopify. You may close this page and try again.');
      } finally {
        setSearchParams({});
      }
    };
    authorize();
    // eslint-disable-next-line
  }, []);

  return (
    <Box className="flex flex-col items-center justify-center min-h-screen bg-gray-100" sx={{ p: 3 }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 600, width: '100%' }}>
        <Typography variant="h5" align="center">
          {message}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ShopifyAuthLanding;